$(document).ready(function(){
  $('.c-news__wrapper_lp').slick({
    infinite: false,  // loopをオフにする
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    centerMode: false,  // 要素の中央配置を有効にする
    variableWidth: true,  // 幅の可変を有効にする
  });


  // top-lp__section--product-collection-list-slider のスライダー設定
  $('.top-lp__section--product-collection-list').slick({
    infinite: false,  // loopをオフにする
    arrows: false,  // 矢印を表示する
    slidesToShow: 1.5,  // 画面に3枚のスライドを表示
    slidesToScroll: 1,
    dots: false,  // ドットナビゲーションを表示する
    centerMode: false,  // 要素の中央配置を無効にする
    variableWidth: true,  // 幅の可変を有効にする
  });





  
});